import { ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  height: '40px',
  '& .MuiToggleButton-root': {
    padding: '6px 18px',
    textTransform: 'lowercase',
    fontWeight: 600,
    fontSize: '13px',
    color: theme.palette.text.secondary,
    borderColor: theme.palette.divider,
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: '#FAFCFF',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.85,
      },
    },
  },
}));
